export default "__VITE_PUBLIC_ASSET__9582159e__"